import {
  getLinks
} from '~api/promotion-links'

export const state = () => ({
  links: [],
  page: {}
})

export const getters = {
  linksGetter: state => state.links,
  pageGetter: state => state.page
}

export const actions = {
  async getLinksByType ({ commit }, params) {
    const response = await getLinks({
      ...params
    })
    const { links, pages } = response
    commit('setLinks', links)
    commit('setLinksPage', pages)

    return response
  }
}

export const mutations = {
  setLinks (state, payload) {
    state.links = payload
  },
  setLinksPage (state, payload) {
    state.page = payload
  }
}
